import Axios from '../../config/axios';

export default function getSupportMessage(prefix) {
    return Axios.get(`/api/GetLocalOfficeAdministrator`).then(response => {
        const { administratorName, administratorEmail, administratorPhone } = response.data;

        return `${prefix} ${administratorName} at ${administratorPhone} or <a href="mailto:${administratorEmail}">${administratorEmail}</a>.`;
    });
}
